<div class="table-responsive ">

    <table class="table datatables-ajax">
        <thead class="table-header-dark-light">
            <tr class=" table-light">
                <th class="side-column  px-1" scope="col">
                    #
                </th>
                <th scope="col"
                    *ngFor="let item of tableOption.tableContent | tableHeader:'Rolestore'">
                    <app-pcard-table-sortabel-button [columnName]="item" [sortOption]="tableOption.sorting" (sortingChange)="tableOption.sorting=$event">
                    </app-pcard-table-sortabel-button>
                    {{ item | translate }}
                </th>
                <th class="side-column  px-1" scope="col">
                    &#160;
                </th>

            </tr>
        </thead>
        <tbody class="table-body-dark-light">
            <tr *ngFor="let item of tableOption.tableContent;let i=index;">
                <td class="side-column  px-1" scop="row">{{ i+1 }}</td>

                <td *ngFor="let key of tableOption.tableContent| tableHeader" [attr.data-label]="item[key]">
                    {{ item[key] | normalLenght }}
                </td>

                <td class="side-column px-1">

                </td>
            </tr>
        </tbody>
    </table>
</div>